
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/template-select.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-template-select-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/template-select.md?type=demo')
};